import React, { useState } from "react";
import { Upload } from "lucide-react";

export default function MediaField({ value, onChange, path, onUploadAsset }) {
  const [busy, setBusy] = useState(false);
  const tid = `field-${path.join(".")}`;
  const handleFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const url = await onUploadAsset(f);
      if (url) onChange(url);
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };
  const previewSrc = value && value.startsWith("/api/uploads/")
    ? `${process.env.REACT_APP_BACKEND_URL}${value}`
    : value;
  const isImg = typeof value === "string" && /\.(jpe?g|png|webp)$/i.test(value);
  return (
    <div className="space-y-2">
      <input
        data-testid={tid}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className="w-full bg-[#080808] border border-white/15 text-[#f5f5f5] p-3 font-mono text-xs focus:outline-none focus:border-white/40"
      />
      <div className="flex items-center gap-3">
        {isImg && <img src={previewSrc} alt="" className="w-16 h-16 object-cover border border-white/10" />}
        <label className="font-mono text-[10px] tracking-[0.25em] uppercase border border-white/20 px-3 py-2 hover:bg-white hover:text-black transition-all cursor-pointer flex items-center gap-2">
          <Upload size={12} /> {busy ? "Uploading…" : "Upload + grade"}
          <input
            type="file"
            accept="image/*"
            className="hidden"
            onChange={handleFile}
            disabled={busy}
            data-testid={`upload-${path.join(".")}`}
          />
        </label>
      </div>
    </div>
  );
}
